import { render, staticRenderFns } from "./CopyThumbnailWeetButton.vue?vue&type=template&id=526a0036&scoped=true"
import script from "./CopyThumbnailWeetButton.vue?vue&type=script&lang=ts"
export * from "./CopyThumbnailWeetButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a0036",
  null
  
)

export default component.exports